import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { I18n } from 'react-redux-i18n';
import getStartedImage from '../../../../../assets/images/setup.png';
import startedIcon from '../../../../../assets/images/icons/started.svg';

const GET_STARTED_SECTION_HIDDEN_KEY = 'getStartedSectionHidden';

const GetStartedSection = () => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    // Check localStorage on mount
    const hidden = localStorage.getItem(GET_STARTED_SECTION_HIDDEN_KEY);
    if (hidden === 'true') {
      setIsHidden(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(GET_STARTED_SECTION_HIDDEN_KEY, 'true');
    setIsHidden(true);
  };

  // Don't render if hidden
  if (isHidden) {
    return null;
  }

  return (
    <div className="get-started-section">
      <div className="get-started-content">
        <div className="get-started-text">
          <div className="get-started-text-content">
            <h2>{I18n.t('billingUsage.getStartedButton')}</h2>
            <p>{I18n.t('billingUsage.getStartedDescription')}</p>
            <Button
              style={{
                padding: '6px 14px',
                borderRadius: '5px',
                minWidth: '200px',
              }}
              variant="outline-light"
              className="get-started-btn"
              onClick={() => {
                window.open('https://www.goodjourney.io/en/guide', '_blank');
              }}
            >
              <div style={{ fontSize: '13px', fontWeight: '500' }}>
                {I18n.t('billingUsage.learnMore')}
              </div>
              <FaArrowRight style={{ marginLeft: '10px', fontSize: '13px' }} />
            </Button>
          </div>
        </div>
        <div className="get-started-video" style={{ position: 'relative' }}>
          <img
            style={{ width: '325px', borderRadius: '10px' }}
            src={getStartedImage}
            alt="Get Started Video"
          />
        </div>
      </div>
    </div>
  );
};

export default GetStartedSection;
